// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"15245c98","967":"838394cc"}[chunkId] + ".chunk.js";
};